<template>
    <div>
        <div class="offcanvas offcanvas-start" style="width:100%;margin-top: 50px;" tabindex="-1" id="offcanvasExample"
            aria-labelledby="offcanvasExampleLabel">
            <div class="offcanvas-header" :style="skin.side_bar.header + skin.side_bar.header_text"
                style="display: none;">
                <button id="closeSideBar" type="button" class="btn text-reset" data-bs-dismiss="offcanvas"
                    aria-label="Close">
                    <span style="color:white;font-size:large"><i class="fas fa-times"></i></span>
                </button>
            </div>
            <div class="offcanvas-body p-0" :style="skin.side_bar.body">
                <div class="p-3">
                    <div class="p-2">
                        <span :style="skin.header_desktop.nav_bar_text">{{ translate('sports') }}</span>
                    </div>
                    <div v-for="item in categories" :key="item.category" @click="change_view(item.category)"
                        style="cursor:pointer;overflow: hidden;border-radius: 6.25rem;"
                        :style="skin.header_desktop.nav_bar_text + skin.my_account.content_background" class="p-2 mb-1">
                        <div class="d-flex">
                            <img :src="item.icon" class="me-1">
                            &nbsp;&nbsp;<span :style="skin.side_bar.navigation_text"
                                style="text-transform: capitalize;">{{ translate(item.name1).toLowerCase() }}</span>
                        </div>
                    </div>
                    <div class="p-2">
                        <span :style="skin.header_desktop.nav_bar_text">{{ translate('games1') }}</span>
                    </div>
                    <div v-for="item in otherCategories" :key="item.category" @click="change_view(item.category)"
                        style="cursor:pointer;overflow: hidden;border-radius: 6.25rem;"
                        :style="skin.header_desktop.nav_bar_text + skin.my_account.content_background" class="p-2 mb-1">
                        <div class="d-flex">
                            <img :src="item.icon" class="me-1">
                            &nbsp;&nbsp;<span :style="skin.side_bar.navigation_text"
                                style="text-transform: capitalize;">{{ translate(item.name).toLowerCase() }}</span>
                        </div>
                    </div>
                    <div class="p-2">
                        <span :style="skin.header_desktop.nav_bar_text">{{ translate('others') }}</span>
                    </div>
                    <div style="cursor:pointer;overflow: hidden;border-radius: 6.25rem;"
                        :style="skin.header_desktop.nav_bar_text + skin.header_desktop.selection" class="p-2 mb-1"
                        @click="openSupportModalJivo()">
                        <div class="d-flex">
                            <svg style="width: 20px;" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_10434_32190)">
                                    <path
                                        d="M18.5625 10.3125C17.6579 10.3125 16.9219 11.0485 16.9219 11.9531V18.5156C16.9219 19.4203 17.6579 20.1562 18.5625 20.1562C19.4671 20.1562 20.2031 19.4203 20.2031 18.5156V11.9531C20.2031 11.0485 19.4671 10.3125 18.5625 10.3125Z"
                                        fill="#EDEDED"></path>
                                    <path
                                        d="M10.5938 19.7812C9.67711 19.7812 8.89556 20.3691 8.60531 21.1875H7.875C7.09495 21.1875 6.43364 20.6697 6.21633 19.9599C6.72947 19.6826 7.07812 19.1399 7.07812 18.5156V11.9531C7.07812 11.047 6.34359 10.3125 5.4375 10.3125C4.53141 10.3125 3.79688 11.047 3.79688 11.9531V18.5156C3.79688 19.1905 4.20455 19.77 4.78697 20.0219C5.05547 21.483 6.3375 22.5938 7.875 22.5938H8.60531C8.89556 23.4121 9.67711 24 10.5938 24C11.7569 24 12.7031 23.0537 12.7031 21.8906C12.7031 20.7275 11.7569 19.7812 10.5938 19.7812Z"
                                        fill="#EDEDED"></path>
                                    <path
                                        d="M16.1099 7.7158H16.0985C16.1062 6.3703 16.1096 4.98636 16.0929 4.78555C16.0531 4.30878 15.7645 3.91925 15.3576 3.7932C14.9526 3.66786 14.5243 3.82217 14.2114 4.20608C13.8879 4.60302 12.4079 7.271 11.962 8.07927C11.8418 8.29705 11.8457 8.56217 11.9722 8.77639C12.0986 8.99061 12.3289 9.12205 12.5776 9.12205H14.6826C14.6801 9.45833 14.6776 9.7805 14.6751 10.073C14.6717 10.4614 14.9838 10.7789 15.3721 10.7822H15.3783C15.7637 10.7822 16.0779 10.4714 16.0812 10.0851C16.0832 9.85367 16.086 9.51631 16.089 9.12205H16.1099C16.4982 9.12205 16.813 8.80724 16.813 8.41892C16.813 8.03061 16.4982 7.7158 16.1099 7.7158ZM14.6919 7.7158H13.7729C14.1075 7.11819 14.4327 6.54519 14.6985 6.08624C14.6976 6.55789 14.6952 7.12677 14.6919 7.7158Z"
                                        fill="#EDEDED"></path>
                                    <path
                                        d="M11.736 6.23705C11.7502 6.14353 11.7757 6.01134 11.7815 5.86481C11.7815 4.6987 10.8328 3.75 9.6666 3.75C8.65827 3.75 7.78555 4.46733 7.59144 5.45569C7.51659 5.83673 7.76484 6.2063 8.14588 6.28111C8.52693 6.35597 8.89649 6.10772 8.9713 5.72667C9.03623 5.39616 9.32863 5.15625 9.66655 5.15625C10.0448 5.15625 10.3548 5.45409 10.3742 5.82759L10.3586 5.95022C10.2919 6.20972 10.1299 6.52781 9.88846 6.87277C9.01555 8.11997 8.49468 8.80195 8.21488 9.16838C7.86351 9.62841 7.68716 9.85931 7.80562 10.2443C7.87569 10.4722 8.04805 10.647 8.27844 10.7238C8.37112 10.7547 8.45465 10.7826 9.54149 10.7826C9.96355 10.7826 10.537 10.7783 11.321 10.7685C11.7093 10.7636 12.0201 10.4449 12.0153 10.0566C12.0104 9.67125 11.6966 9.36225 11.3124 9.36225C11.3094 9.36225 11.3063 9.36225 11.3034 9.3623C10.8045 9.36858 10.2774 9.37294 9.82129 9.37444C10.1197 8.97305 10.5187 8.42484 11.0407 7.67911C11.3989 7.16705 11.6329 6.68189 11.736 6.23705Z"
                                        fill="#EDEDED"></path>
                                    <path
                                        d="M23.0156 12.0752V11.0156C23.0156 8.07323 21.8698 5.307 19.7892 3.22645C17.7086 1.14581 14.9424 0 12 0C9.05761 0 6.29138 1.14581 4.21078 3.22641C2.13019 5.30695 0.984375 8.07323 0.984375 11.0156V12.0752C0.419484 12.4541 0.046875 13.0983 0.046875 13.8281V16.6406C0.046875 17.8037 0.993141 18.75 2.15625 18.75H2.39062V11.0156C2.39062 5.71702 6.70139 1.40625 12 1.40625C17.2986 1.40625 21.6094 5.71697 21.6094 11.0156V18.75H21.8438C23.0069 18.75 23.9531 17.8037 23.9531 16.6406V13.8281C23.9531 13.0983 23.5805 12.4541 23.0156 12.0752Z"
                                        fill="#EDEDED"></path>
                                </g>
                                <defs>
                                    <clipPath id="clip0_10434_32190">
                                        <rect width="24" height="24" fill="white"></rect>
                                    </clipPath>
                                </defs>
                            </svg>
                            &nbsp;&nbsp;<span :style="skin.side_bar.navigation_text">{{ translate('soporte') }}</span>
                        </div>
                    </div>
                    <div v-if="!skin.lobby">
                        <languageSelector :skin="skin" :language="language" :movil="movil">
                        </languageSelector>
                    </div>
                </div>
            </div>
            <historialIngresos v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
        </div>
    </div>
</template>

<script>
import languageSelector from '../../header/language.vue';
import historialIngresos from "../../header/historialIngresos.vue";

export default {
    name: 'Sidebar',
    components: {
        languageSelector,
        historialIngresos
    },
    props: ['translation', 'language'],
    data() {
        return {
            categories: [],
            movil: 'mobile',
            otherCategories: [],
            booking_code: '',
        }
    },
    computed: {
        jivo_modal_flag() {
            return this.$store.getters["getModalFlag"]
        },
        jivoElement1() {
            return this.$store.getters['jivoElement1'];
        },
        favoritos() {
            return this.$store.getters['live/getFavorites'];
        },
        sports() {
            return this.$store.getters['live/getSports'];
        },
        skin() {
            return this.$store.getters['getCurrentSkin'];
        },
        user() {
            return this.$store.getters['getUserData'];
        },
        prematchTarget() {
            return this.$store.getters['getPrematchTarget'];
        },
        time2() {
            return this.$store.getters['prematch_2/getTime'];
        },
        timeLoading() {
            return this.$store.getters['prematch_2/getTimeLoading'];
        },
        sports_prematch() {
            return this.$store.getters['prematch_2/getSports'];
        },
        nav_activeCss() {
            return {
                '--bar': this.skin.side_bar.nav_active_bar,
                '--text': this.skin.side_bar.nav_active_text,
            }
        },
        config() {
            return this.$store.getters['getConfig'];
        },
    },
    methods: {
        async loadCategories() {
            if (this.skin.categories) {
                this.categories = this.skin.categories.filter(category =>
                    category.active &&
                    ["sport", "sportlive"].includes(category.category)
                );
                this.otherCategories = this.skin.categories.filter(category =>
                    category.active && !["sport", "sportlive", "lobby"].includes(category.category)
                );
            }
        },
        openSupportModalJivo() {
            const sidebarEl = document.getElementById('offcanvasExample');
            const instance = bootstrap.Offcanvas.getInstance(sidebarEl);
            instance.hide();
            const jivoMobileElement = this.jivoElement1;
            if (this.jivo_modal_flag) {
                if (jivoMobileElement) {
                    jivoMobileElement.style.display = 'none'; // Ocultar el elemento móvil
                }
                this.$store.dispatch("setJivo_modal_flag", false);
            } else {
                if (jivoMobileElement) {
                    jivoMobileElement.style.display = 'block'; // Mostrar el elemento móvil
                    jivo_api.open()
                }
                this.$store.dispatch("setJivo_modal_flag", true);
                this.$store.dispatch("setMessage", false);
            }
        },
        translate(text) {
            if (this.$props.translation[text]) {
                return this.$props.translation[text][this.$props.language];
            }
            return text;
        },
        active: function (id) {
            let items = document.getElementsByClassName("item-menu");
            [...items].forEach(item => {
                item.classList.remove('nav_active1');
                item.classList.remove('active');
            });
            document.getElementById(id).classList.add('nav_active1');
            document.getElementById(id).classList.add('active');
        },
        check_booking() {
            if (this.booking_code != '') {
                this.$store.dispatch('getBooking', this.booking_code);
            }
            else {
                this.alert.message = this.translate('Ingresa un código de reserva válido');
                this.alert.type = 'danger';
                this.alert.active = true;
                setTimeout(this.alert_off, 5000);
            }
        },
        change_view(view) {
            document.getElementById('closeSideBar').click();
            this.$store.dispatch("changeView", view);
        },
        terms() {
            let url = "";
            let lang = this.$props.language == 'es' ? 'spa' : (this.$props.language == 'en' ? 'eng' : (this.$props.language == 'pt' ? 'pt-br' : 'spa'));
            if (this.user.prefix == "external") {
                url = "https://docs.betsw3.xyz/terms/" + lang + "/?site=" + this.user.site.toUpperCase() + "&link=" + this.user.site;
            }
            else {
                let domain_formated = this.user.domain.split('//')[1];
                let domain_name1 = domain_formated.split('.')[1].toUpperCase();
                let domain_name2 = domain_formated.split('.')[1] + '.' + domain_formated.split('.')[2];
                url = "https://docs.betsw3.xyz/terms/" + lang + "/?site=" + domain_name1 + "&link=" + domain_name2;
            }

            window.open(url, '_blank').focus();
        },
    },
    async mounted() {
        await this.loadCategories();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.input-group2 {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
}

.nav_active1 {
    color: var(--text);
    border-bottom: var(--bar);
}
</style>
